import React from "react";
import {
  ProductPageContext,
  ProductPageContextProvider,
} from "./ProductPageView";
import ProductPage from "./views/ProductPage";

const ProductList = () => {
  return (
    <ProductPageContextProvider>
      <ProductPage />
    </ProductPageContextProvider>
  );
};

export default ProductList;
